<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Project/POA/components/Evaluation/Middle/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>